import PillboxMenuContainer from './containers/PillboxMenuContainer.js'
export const containers = {
  PillboxMenuContainer,
}
